import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

// Store
import {
  loadServicesState,
  loadServicesStateError,
  loadServicesStateSuccess,
} from './services.actions';
import { toggleLoaderState } from '../loader/loader.actions';

// Services
import { CategoryService } from '@services/category.service';

// Interfaces
import { IIcon } from '@interfaces/icon.interface';

@Injectable()
export class ServicesEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store);
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);
  private categoryService = inject(CategoryService);

  loadServicesList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadServicesState),
      switchMap(() => {
        this.store$.dispatch(toggleLoaderState({ state: true }));

        return this.categoryService.getCategories().pipe(
          map(servicesData => {
            this.registerIcons(servicesData.services);
            this.store$.dispatch(toggleLoaderState({ state: false }));
            return loadServicesStateSuccess({ services: servicesData });
          }),
          catchError(error => {
            this.store$.dispatch(toggleLoaderState({ state: false }));
            return of(loadServicesStateError({ error }));
          }),
        );
      }),
    ),
  );

  registerIcons(listIcons: IIcon[]): void {
    listIcons.forEach(item => {
      if (item?.icon_svg) {
        this.iconRegistry.addSvgIcon(item.name, this.getSecurityUrl(item.icon_svg));
      }
    });
  }

  getSecurityUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url) as SafeResourceUrl;
  }
}
